import React, { useContext, useEffect, useState } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import { Loader } from '@mummssoftware/common-ui';
import type { FaxLogRecord } from '@mummssoftware/utils';
import { FaxLogContext } from '../../context';
import { FaxPdfBlobViewer } from './FaxPdfBlobViewer';
import { fetchPdfBlobFromBucket } from './fetchPdfFromBucket';
import defaults from '../../translations/en.json';

type FaxPdfViewerModalProps = {
  row: FaxLogRecord | null;
  onClose: () => void;
};

export const FaxPdfViewerModal = ({ row, onClose }: FaxPdfViewerModalProps) => {
  const { keycloak } = useContext(FaxLogContext);
  const [pdfBlob, setPdfBlob] = useState<Blob | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    const loadPdf = async () => {
      setPdfBlob(null);
      setError(null);

      if (!row?.documentUrl) {
        return;
      }

      try {
        const blob = await fetchPdfBlobFromBucket(row.documentUrl, keycloak);
        if (mounted) {
          setPdfBlob(blob);
        }
      } catch {
        if (mounted) {
          setError(defaults.pdfLoadError as string);
        }
      }
    };

    if (row) {
      loadPdf();
    }

    return () => {
      mounted = false;
    };
  }, [keycloak, row]);

  return (
    <Dialog
      open={!!row}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          height: 'calc(100vh - 48px)',
          maxHeight: 'calc(100vh - 48px)',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <DialogContent
        style={{
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {!pdfBlob && !error && <Loader />}
        {error && <span>{error}</span>}
        {pdfBlob && <FaxPdfBlobViewer file={pdfBlob} />}
      </DialogContent>
    </Dialog>
  );
};
